<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h1 class="text-white">Exam Circulars</h1>
                    <ul class="breadcrumb">
                        <li>
                            <a routerLink="/">Academics</a>
                        </li>
                        /
                        <li class="active">
                            <a href="javascript:void(0);">Exam Circulars</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span>Exam Circulars</span></h2>
        </div>
        <ul class="list-before">
            <li><a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/notification/Exam-form-notice-Winter2024.pdf"
                    target="_blank">ESE exam notice winter 2024</a></li>
        </ul>
    </div>
</section>
